export default __webpack_public_path__ + "static/media/client_logo2.11fd2cf9.png";